import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/Production_Management/Item_Staging_Process/AddItemStagingProcess';
import Edit from '../../../../modal/Settings/Production_Management/Item_Staging_Process/EditItemStagingProcess';
import EditItemStagingProcess from '../../../../modal/Settings/Production_Management/Item_Staging_Process/EditItemStagingProcess';
import axios from 'axios';


const StagingProcessName = () => {
   const baseURL = process.env.REACT_APP_API_BASE_URL;
    const tableRef = useRef(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [itemStagging, setItemStagging] = useState([]);
    const [totalEntries, setTotalEntries] = useState(0);

    
    // Fetch checklist priorities from API
    const fetchCategories = async (pageNumber = 1, perPageCount = 25, search = '') => {
        try {
            const response = await axios.get(`${baseURL}/itemstagging`, {
                params: {
                    page: pageNumber,
                    per_page: perPageCount,
                    search: search,
                },
            });
            const data = response.data;
            setItemStagging(data.data || []);
            setTotalPages(data.pagination?.last_page || 1);
            setTotalEntries(data.pagination?.total || 0);
        } catch (error) {
            console.error('Error fetching item categories:', error);
        }
    };

    useEffect(() => {
        fetchCategories(page, perPage, searchTerm);
    }, [page, perPage, searchTerm]); 

    const handleModalToggle = () => { 
        setModalType("Add");  // Set the modal type to "Add"
        setOpen(true);  // Toggle the modal visibility
    };
    const handleModalToggle_Edit = () => {
        setModalType("Edit");  // Set the modal type to "Add"
        setOpen(true);
    };

    // Modal states
        const [open, setOpen] = useState(false);
        const [modalType, setModalType] = useState("");
        const [selectedPriorityId, setSelectedPriorityId] = useState(null);


     const refreshData = () => {
        fetchCategories(page, perPage, searchTerm);
    };

    ;

    // Open edit modal with selected priority ID
    const handleEditClick = (priorityId) => {
        setModalType("Edit");
        setSelectedPriorityId(priorityId);
        setOpen(true);
    };
    
    // Delete confirmation modal and API call
    const DeleteModal = (categoryId, categoryName) => {
        swal.fire({
            html: `
                <div className="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Products
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p className="text-center"><b>${categoryName}</b></p>  
                <div className="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <!-- SVG content omitted for brevity -->
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/itemstagging/${categoryId}`)
                    .then(() => {
                        swal.fire({
                            title: 'Item Stagging Deleted!',
                            text: `${categoryName} has been marked as deleted.`,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(() => {
                            fetchCategories(page, perPage, searchTerm);
                        });
                    })
                    .catch((error) => {
                        const errorMsg = error.response?.data?.message || 'Something went wrong while deleting.';
                        swal.fire({
                            title: 'Error!',
                            text: errorMsg,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                        });
                    });
            } else {
                swal.fire({
                    title: 'Delete Cancelled',
                    text: `${categoryName} was not deleted.`,
                    icon: 'info',
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                });
            }
        });
    };

 
        // Toggle status (active/inactive)
        const handleStatusChange = (categoryId, currentStatus) => {
            const newStatus = currentStatus === 0 ? 1 : 0;
            axios.post(`${baseURL}/itemstagging/status/${categoryId}`, { status: newStatus })
                .then(() => {
                    fetchCategories(page, perPage, searchTerm);
                })
                .catch(error => {
                    console.error("Error updating status:", error);
                });
        };


        const getTimingLabel = (timing) => {
  switch (timing) {
    case 0: return 'Before Production';
    case 1: return 'During Production';
    case 2: return 'After Production';
    default: return 'Unknown';
  }
};


const parseDurationToHours = (duration) => {
  const match = duration.match(/(\d+)h\s*(\d+)m\s*(\d+)s/);
  if (!match) return 0;
  const [, h, m, s] = match.map(Number);
  const totalHours = h + m / 60 + s / 3600;
  return totalHours.toFixed(1); // keep 1 decimal
};

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles flex-wrap px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Item Staging Process</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>  
                </div>
                <Link to={"#"} className="btn btn-primary float-end btn-sm mb-2" onClick={handleModalToggle}>
                    <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                    <span className=''>Add Staging Process</span>
                </Link>
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} />
                )}
                {/* {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} />
                )} */}

                 {open && modalType === "Edit" && (
                                    <EditItemStagingProcess
                                        show={open}
                                        onClose={() => setOpen(false)}
                                        priorityId={selectedPriorityId}
                                        onUpdated={refreshData}
                                    />
                                )}
            </div>
            <div className="table-container">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{ fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1);
                            }}
                        >
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={75}>75</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    <div>
                        <input
                            type="text"
                            style={{ fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1);
                            }}
                        />
                    </div>
                </div>

                <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head"> 
                            <th className='min-w-100px'>Process Name</th>
                            <th className='min-w-100px text-center'>Staging Time </th>
                            {/* <th className='min-w-300px text-center'>Pre/Post Production Duration</th> */}
                            <th className='min-w-100px'>Work Duration</th>
                            <th className='min-w-100px'>Status</th>
                            <th className='min-w-100px'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                         
                        {itemStagging.map((category) => (
                        <tr>
                           
                            <td>
                                <label className='text-black font-w400 fs-7'>{category.itemstagging_name}</label>
                            </td>

                            <td className='text-center'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Pre/Post Production Duration</span></Tooltip>} >
                                    <Badge bg="none" className='border border-danger text-danger font-w400 fs-7 py-0 px-1'>
                                         {parseDurationToHours(category.working_hours)} Hours
                                        {/* {category.working_hours} Hours */}
                                        
                                         </Badge>
                                </OverlayTrigger>
                                <span> - </span> 
                                <Badge bg="none" className='border border-primary text-primary py-0 px-2 fs-7'>
                                {getTimingLabel(category.timing)}
                                </Badge>
                            </td>
                            <td>
                                <label className='text-black font-w400 fs-7'>
                                   
                                    {category.working_duration}
                                    </label>
                            </td>
                            <td>
                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                        <input
                                            className="form-check-input me-2"
                                            type="checkbox"
                                            role="switch"
                                            checked={category.status === 0}
                                            onChange={() => handleStatusChange(category.sno, category.status)}
                                        />
                                    </div>
                            </td>
                            <td>
                                <span class="text-end">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                        // onClick={handleModalToggle_Edit}
                                               onClick={() => handleEditClick(category.sno)}
                                        >
                                            <span><i class="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                    {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                        // onClick={DeleteModal}
                                        onClick={() => DeleteModal(category.sno, category.itemstagging_name)}
                                        >
                                            <span><i class="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger> */}
                                </span>
                            </td>
                        </tr>
                        ))}

                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                        {itemStagging.length > 0 && (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + itemStagging.length} of {totalEntries} entries
                            </span>
                        )}
                    </div>

                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>

            </div>
        </>
    )


}
export default StagingProcessName;